import * as bi from 'react-icons/bi';
import fleetImg from '../../images/AE-img-7.jpeg';

const Contact = () => {
    const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const lat = -26.50207459790029;
    const lng = 31.311816637532015;

    return (
        <>
            <section id="contact" className="contact">
                <div className="container mx-auto px-4">
                    <div className="section-title">
                        <h2>Contact</h2>
                    </div>
                    <div className="flex flex-wrap info" data-aos="fade-in">
                        <div className="w-full flex flex-col lg:flex-row">
                            <div className="w-full lg:w-1/3 p-4 flex justify-center">
                                <i className="text-2xl"><bi.BiMap /></i>
                                <h4>Location:</h4>
                                <p>Lot 810 Cnr Lifahlawane St &, Shiselweni Ave
                                    Matsapha M202, Eswatini</p>
                            </div>

                            <div className="w-full lg:w-1/3 p-4 flex justify-center">
                                <i className="text-2xl"><bi.BiEnvelope /></i>
                                <h4>Email:</h4>
                                <div className="flex-col">
                                    <p>info@alternative.co.sz</p>
                                    <p>admin@alternative.co.sz</p>
                                </div>
                            </div>

                            <div className="w-full lg:w-1/3 p-4 flex justify-center">
                                <i className="text-2xl"><bi.BiPhone /></i>
                                <h4>Call:</h4>
                                <div className="flex-col">
                                    <p>+268 2518 5414</p>
                                    <p>+268 2518 7424</p>
                                </div>
                            </div>
                        </div>

                        {/* Fleet / Premises Image */}
                        <div className="w-full mt-8 p-4">
                            <img
                                src={fleetImg}
                                alt="Alternative Energy fleet and premises"
                                className="w-full object-cover rounded-lg shadow-md"
                                style={{ maxHeight: '450px', objectFit: 'cover' }}
                            />
                        </div>

                        <div className="w-full mt-8 p-4">
                            <h4 className="mb-4">Find Us Here:</h4>
                            <div style={{ height: '400px', width: '100%' }}>
                                <iframe
                                    title="Alternative Energy Location"
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                    loading="lazy"
                                    allowFullScreen
                                    referrerPolicy="no-referrer-when-downgrade"
                                    src={`https://www.google.com/maps/embed/v1/place?key=${GOOGLE_MAPS_API_KEY}&q=Alternative+Energy+Eswatini&center=${lat},${lng}&zoom=17`}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Contact;